import { apiGet } from "../ApiMethod";
import { setRole } from "../../mappers";

export const roleList = async (params = {}) => {
  const response = await apiGet("_role", params);
  const { data, ...rest } = response;
  return { ...rest, data: data.map(setRole) };
};